import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps, drawerClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
const borderRadius = '16px';

export type DrawerCloseReason = 'backdropClick' | 'escapeKeyDown' | 'closeButton';
export type DrawerOnClose = (event: object, reason: DrawerCloseReason) => void;

export interface DrawerProps extends Omit<MuiDrawerProps, 'onClose'> {
  onClose?: DrawerOnClose;
}

const StyledDrawer = styled(MuiDrawer)<MuiDrawerProps>(({ anchor, theme }) => ({
  [`& .${drawerClasses.paper}`]: {
    padding: '0 24px',
    ...(anchor === 'right' && {
      borderTopLeftRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
      width: '320px',
      [theme.breakpoints.up('md')]: { width: '464px' },
    }),
    ...(anchor === 'left' && {
      borderTopRightRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
      width: '320px',
      [theme.breakpoints.up('md')]: { width: '464px' },
    }),
    ...(anchor === 'top' && {
      borderBottomLeftRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
    }),
    ...(anchor === 'bottom' && {
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius,
    }),
  },
}));

export function Drawer({ children, ...props }: DrawerProps) {
  return <StyledDrawer {...props}>{children}</StyledDrawer>;
}
